import { useState, useEffect } from 'react'
import AdminTable from '../../components/admin/AdminTable'
import AdminForm from '../../components/admin/AdminForm'
import { motion, AnimatePresence } from 'framer-motion'

const API = import.meta.env.VITE_API_URL || '/api'
function getHeaders() { const t = localStorage.getItem('token'); return { 'Content-Type': 'application/json', Authorization: t ? `Bearer ${t}` : '' } }

const fields = [
  { name: 'name', label: 'Name', type: 'text' as const, required: true },
  { name: 'category', label: 'Category', type: 'text' as const },
  { name: 'logo', label: 'Logo URL (leave empty for auto-generated)', type: 'text' as const },
  { name: 'gradient', label: 'Gradient (optional)', type: 'text' as const },
  { name: 'sort_order', label: 'Sort Order', type: 'number' as const },
]

export default function AdminClients() {
  const [items, setItems] = useState<any[]>([])
  const [editing, setEditing] = useState<any | null>(null)
  const [showForm, setShowForm] = useState(false)
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)

  const fetchItems = async () => { const r = await fetch(`${API}/clients`); setItems(await r.json()); setLoading(false) }
  useEffect(() => { fetchItems() }, [])

  const handleSave = async (data: any) => {
    setSaving(true); const isNew = !editing
    const r = await fetch(isNew ? `${API}/clients` : `${API}/clients/${data.id}`, { method: isNew ? 'POST' : 'PUT', headers: getHeaders(), body: JSON.stringify(data) })
    if (r.ok) { await fetchItems(); setShowForm(false); setEditing(null) }
    setSaving(false)
  }

  const handleDelete = async (item: any) => { await fetch(`${API}/clients/${item.id}`, { method: 'DELETE', headers: getHeaders() }); await fetchItems() }

  const columns = [
    { key: 'logo', label: '', render: (v: string, row: any) =>
      v ? <img src={v} className="w-8 h-8 object-contain rounded" /> :
        <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-electric-blue to-cyan-400 flex items-center justify-center text-[10px] font-bold text-white">{row.name?.charAt(0)}</div>
    },
    { key: 'name', label: 'Name', render: (v: string) => <span className="font-medium">{v}</span> },
    { key: 'category', label: 'Category' },
  ]

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-white">Clients</h1>
        <button onClick={() => { setEditing(null); setShowForm(true) }} className="px-4 py-2 bg-electric-blue hover:bg-electric-blue/80 text-white rounded-lg text-sm">+ Add Client</button>
      </div>
      <div className="bg-gray-900 border border-white/10 rounded-xl p-5">
        <AdminTable columns={columns} data={items} onEdit={(i) => { setEditing(i); setShowForm(true) }} onDelete={handleDelete} loading={loading} />
      </div>
      <AnimatePresence>
        {showForm && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="fixed inset-0 z-50 bg-black/60 flex items-start justify-center pt-20 p-4 overflow-y-auto">
            <motion.div initial={{ scale: 0.95, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.95, opacity: 0 }} className="bg-gray-900 border border-white/10 rounded-2xl p-6 w-full max-w-2xl">
              <h2 className="text-xl font-bold text-white mb-6">{editing ? 'Edit Client' : 'Add Client'}</h2>
              <AdminForm fields={fields} initial={editing || { id: `c${Date.now()}`, name: '', category: '', logo: '', gradient: '', sort_order: 0 }} onSubmit={handleSave} onCancel={() => { setShowForm(false); setEditing(null) }} loading={saving} />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}
